import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class UserGroupEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "UserGroup";
        this.primaryEnterpriseComponent = "UserGroup";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "UserGroup";
        eom.enterpriseComponent = "UserGroup";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "UserGroupAccountUser";
        eom.enterpriseComponent = "UserGroupAccountUser";
        eom.relationship = "UserGroupUserGroupAccountUser";
        this.enterpriseComponentMembers.set(eom.name, eom);

    }
}

export default UserGroupEnterpriseObjectMetadata;